import { render, staticRenderFns } from "./fbtextarea.vue?vue&type=template&id=ebeafa4e&"
import script from "./fbtextarea.vue?vue&type=script&lang=js&"
export * from "./fbtextarea.vue?vue&type=script&lang=js&"
import style0 from "./fbtextarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports